import React from "react"

const defaultContextValue = {
  data: {
    // set your initial data shape here
    themeName: "milkshakes",
  },
  set: () => {},
}

const frealThemeContext = React.createContext(defaultContextValue)
const { Provider, Consumer } = frealThemeContext

class ThemeContextProviderComponent extends React.Component {
  constructor() {
    super()

    this.setData = this.setData.bind(this)
    this.state = {
      ...defaultContextValue,
      set: this.setData,
    }
  }

  setData(newData) {
    this.setState(state => ({
      data: {
        ...state.data,
        ...newData,
      },
    }))
  }

  render() {
    return <Provider value={this.state}>{this.props.children}</Provider>
  }
}

export { Consumer as default, frealThemeContext, ThemeContextProviderComponent }
